module.exports = __webpack_public_path__ + "51ef6b5205abf009a264b48232e329ba.svg";